var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.subTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }